import { useState } from 'react';
import { toast } from 'sonner';
import { Smartphone } from 'lucide-react';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';
import { Button } from './ui/button';

export function PhonePrompt({ hasPendingWin }) {
  const { user, refresh } = useAuth();
  const [phone, setPhone] = useState(user?.phone || '');
  const [edit, setEdit] = useState(!user?.phone);
  const save = async (e) => {
    e.preventDefault();
    try { await api.put('/me/phone', { phone }); toast.success('Numéro enregistré'); setEdit(false); refresh(); }
    catch (err) { toast.error(err?.response?.data?.detail || 'Erreur'); }
  };
  return (
    <div className={`card-elev rounded-2xl p-4 ${hasPendingWin && !user?.phone ? 'border border-amber-500/50' : ''}`} data-testid="phone-prompt">
      <div className="font-display font-bold flex items-center gap-2 text-sm"><Smartphone className="h-4 w-4 text-sky-400" />Rappels SMS</div>
      {!edit ? (
        <div className="mt-2 flex items-center justify-between gap-2 text-sm">
          <span className="font-mono-num" data-testid="phone-current">{user?.phone}</span>
          <button onClick={() => setEdit(true)} data-testid="phone-edit" className="text-xs text-slate-400 hover:text-white">Modifier</button>
        </div>
      ) : (
        <form onSubmit={save} className="mt-2 space-y-2">
          <p className="text-xs text-slate-400">{hasPendingWin && !user?.phone ? '🏆 Vous avez gagné une enchère ! Ajoutez votre numéro pour recevoir un rappel SMS si le paiement reste en attente.' : 'Recevez un SMS si un paiement reste en attente.'}</p>
          <div className="flex gap-2">
            <input data-testid="phone-input" type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="77 123 45 67"
              className="flex-1 px-3 py-2 rounded-xl bg-slate-900 border border-slate-700 text-white outline-none text-sm" />
            <Button type="submit" size="sm" data-testid="phone-save" className="btn-brand text-white">OK</Button>
          </div>
        </form>
      )}
    </div>
  );
}
